let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kI0Rj")).then(() => parcelRequire('ieUfL'));